import { Col } from '../../cols/col.class';
import { Sorter as Srt } from 'projects/exi-ui/src/lib/utils/sorter.class';
import { AbstractSorter, DefaultSort } from '../abstract/sorter.class';
import { RemoteTable } from './table.class';
import { SortScheme } from 'projects/exi-ui/src/lib/utils/sorter.class';

export type RemoteSorter<D extends object> = (nextScheme: SortScheme<D>) => Promise<boolean>;


export interface RemoteSort<D extends object> {
   default: DefaultSort;
   onChange: RemoteSorter<D>;
}


export class Sorter<D extends object> extends AbstractSorter<D> {
   private sorter: RemoteSorter<D>;

   constructor(ctx: RemoteTable<D>, sort: RemoteSort<D>) {
      super(ctx, sort.default)
      this.sorter = sort.onChange;
   }


   public sortByCol(col: Col<D>) {
      const toState = new Srt().getNextSortState(col.sortable.state);
      this.lastChain = this.getSortScheme(col, toState);
      this.sorter(this.lastChain).then(isSuccess => {
         if (isSuccess) {
            col.sortable.state = toState;
            this.clearOtherStates();
         }
      });
   }


   public sortByDefault() {
      console.log(`By Default`)
   }


   public sortByLast() {
      console.log(`By last`)
   }


   public setNextSortScheme(col: Col<D>) {
      this.lastChain = this.getSortScheme(col, col.sortable.state);
   }

}

